import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import moment from "moment";
import { toast } from "react-toastify";
import Modal from "react-modal";

const PalletizationForm = (props) => {
  const frmRef = useRef({});
  const productRef = useRef({});
  const [loading, setLoading] = useState(false);

  const [decimalPattern, setDecimalPattern] = useState(
    localStorage.getItem("decimalPattern")
  );
  const [integerPattern, setIntegerPattern] = useState(
    localStorage.getItem("integerPattern")
  ); // ;

  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
      top: 50,
      left: 40,
    },
    content: {
      top: "50%",
      left: "55%",
      transform: "translate(-50%, -50%)",
      maxWidth: "80%",
      width: "900px",
      minHeight: "500px",
      height: "80%",
      minHeight: "auto",
      overflow: "auto",
      border: "5px solid #96dc00",
    },
  };

  const currentDate = new Date().toISOString().slice(0, 10);
  var d = new Date();
  var dateString =
    d.getDate() +
    "/" +
    (d.getMonth() + 1) +
    "/" +
    d.getFullYear() +
    " " +
    d.getHours() +
    ":" +
    d.getMinutes() +
    ":" +
    d.getSeconds();
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  const [productDetails, setProductDetails] = useState([]);
  const [close, setClose] = useState(false);
  const [lotitem, setlotitem] = useState();
  const [lotData, setlotData] = useState([]);
  const rangeRef = useRef({});
  const [rangeDetails, setRangeDetails] = useState([]);
  const [rangeClose, setRangeClose] = useState(false);
  const [batchNo, setbatchNo] = useState();
  const [stockId, setstockId] = useState([]);

  const [employeelist, setEmployeelist] = useState(null);
  const [assignEmployeeId, setAssignEmployeeId] = useState();
  const [weightUnits, setWeightUnits] = useState([]);
  const [lotNo, setlotNo] = useState();
  const [otherProductData, setotherProductData] = useState([]);
  const [otherProductId, setotherProductId] = useState();
  const [availableAmount, setavailableAmount] = useState();
  const [unitId, setunitId] = useState();
  const [emptypalletList, setemptypalletList] = useState();
  const [availableBoxCount, setavailableBoxCount] = useState();
  const [boxesList, setboxesList] = useState([]);
  const [remaingBoxesList, setremaingBoxesList] = useState([]);
  const [remainingEmptypalletList, setremainingEmptypalletList] = useState();
  const [palletId, setpalletId] = useState();
  const [fromPackedId, setfromPackedId] = useState();
  const [toPackedId, settoPackedId] = useState();
  const [selectedBoxesList, setselectedBoxesList] = useState([]);

  const { sendRequest: getEmp } = useHttp();

  useEffect(() => {
    getEmp(
      {
        url: `/api/employee/?useCase=Warehouse&orgId=${localStorage.getItem(
          "orgId"
        )}`,
        //url: `/api/getEmps/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        //console.log("emp", data.output);
        setEmployeelist(data.output);
      }
    );
  }, [getEmp]);

  const { sendRequest: getunits } = useHttp();

  useEffect(() => {
    getunits(
      {
        url: `/api/units?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (res) => {
        if (res) {
          //console.log(res);
          const weightUnits =
            res && res.filter((item) => item.unitTypeName == "Weight");
          setWeightUnits(weightUnits);
        }
      }
    );
  }, [getunits]);

  const { sendRequest: getemptypalletList } = useHttp();

  useEffect(() => {
    getemptypalletList(
      {
        url: `/api/emptypalletList/?warehouseId=${localStorage.getItem(
          "warehouseId"
        )}`,
      },
      (res) => {
        if (res) {
          //console.log("PalletList", res.PalletList);

          setemptypalletList(res.PalletList);
          setremainingEmptypalletList(res.PalletList);
        }
      }
    );
  }, [getemptypalletList]);

  const { sendRequest: getproduct } = useHttp();

  useEffect(() => {
    getproduct(
      {
        url: "/api/product/",
      },
      (res) => {
        if (res) {
          //console.log("product", res);

          var Otherinputproduct = res.filter(
            (item) => (item.varietyId || 0) == 0
          );
          //console.log("Otherinputproduct", Otherinputproduct);
          setotherProductData(Otherinputproduct);
        }
      }
    );
  }, [getproduct]);

  const { sendRequest: getLot } = useHttp();

  useEffect(() => {
    const data = {
      warehouseId: parseInt(localStorage.getItem("warehouseId")),
      process: "PLZ",
    };
    getLot(
      {
        url: "/api/getStockLotForPackhouseProcess/",
        method: "POST",
        body: data,
      },
      (data) => {
        console.log(data);

        setlotData(data);
      }
    );
  }, [getLot]);

  const { sendRequest: getAvailableStock } = useHttp();

  const loadStockData = (id) => {
    productRef.current.productSubType.value = "";
    productRef.current.productType.value = "";
    //console.log("selectedItem", otherProductData);
    var itemlist = otherProductData.filter((item) => item.productId == id);
    var selectedItem = itemlist[0];
    //console.log("selectedItem", selectedItem);
    //console.log("selectedItem", selectedItem);
    productRef.current.productSubType.value = selectedItem.productSubTypeName;
    productRef.current.productType.value = selectedItem.productTypeName;
    const data = {
      warehouseId: localStorage.getItem("warehouseId"),
      productId: id,
    };

    getAvailableStock(
      {
        url: "/api/getAvailableStock/",
        method: "POST",
        body: data,
      },
      (myres) => {

        var res=myres.data
        //console.log("getAvailableStock", res);
        productRef.current.availableQuantity.value = res.availableQty;
        productRef.current.productUnit.value = res.unitName;
        productRef.current.unitId.value = res.unitId;
        productRef.current.availableAmount.value = res.availableAmount;
        setavailableAmount(res.availableAmount);
        setunitId(res.unitId);
      }
    );
  };

  const { sendRequest: postPalletization } = useHttp();

  const handleLotIdChange = (e) => {
    //console.log(e.target.value);
    const id = e.target.value;
    setstockId(id);
    const data = lotData && lotData.filter((item) => item.stockId == id);
    const vId = data[0].varietyId;

    setlotitem(data[0]);
    //console.log("data", data);
    setlotNo(data[0].lotNo);
    setbatchNo(data[0].batchNo);
    setavailableBoxCount(data[0].productQuantityBal);
    setboxesList(data[0].boxDetail);
    setremaingBoxesList(data[0].boxDetail);
    // //console.log("vId", vId);
    // setinputProductId(data[0].productId);
    // setVarietyId(data[0].varietyId || "");
    // //console.log("productMainData", productMainData);
    // var packproduct = productMainData.filter(
    //   (item) => item.varietyId == vId && item.packagingTypeId > 0
    // );
    // //console.log("packproduct", packproduct);
    // setPackagingVarietyProduct(packproduct);
    // frmRef.current.totalQuantity.value = data[0].productQuantityBal;
    // frmRef.current.totalInputQuantity.value = data[0].productQuantityBal;
    // setinputProductUnitId(data[0].unitId);
  };

  const handlePalletIdChange = (e) => {
    //console.log(e.target.value);
    const id = e.target.value;
  };

  const submitHandler = (e) => {
    e.preventDefault();
    setLoading(true);

    const data = {
      palletDate: moment(frmRef.current.date.value).format("DD/MM/YYYY"),
      supervisorEmployeeId: assignEmployeeId,
      stockId: stockId,
      palletizationTime: frmRef.current.packingTime.value,
      totalInputQuantity: frmRef.current.availableBoxCount.value,
      unitId: lotitem.unitId,
      productDetails: productDetails,

      packedItemIdRange: rangeDetails,
      remark: frmRef.current.remark.value,
      status: 1,
      createdBy: parseInt(localStorage.getItem("id")),
      createdDate: dateString,
      orgId: localStorage.getItem("orgId"),
      warehouseId: parseInt(localStorage.getItem("warehouseId")),
      serviceId: props.sId,
    };
    //console.log(data);
    if (props.update) {
      data["palletId"] = props.update.palletId;
    }

    postPalletization(
      {
        url: "/api/palletization/",
        method: props.update ? "PUT" : "POST",
        body: data,
      },
      (data) => {
        //console.log(data);

        props.addForm(false);
        toast.success("Palletization done successfully");
        setLoading(false);
      },
      (error) => {
        console.error("Error", error);
        toast.error(error);
        setLoading(false);
      }
    );
  };

  useEffect(() => {
    //   //console.log(props.update);

    if (props.update) {
      frmRef.current.date.value = moment(props.update.palletDate).format(
        "YYYY-MM-DD"
      );
      frmRef.current.emp_id.value = props.update.SupervisorEmployeeId;
      frmRef.current.lot_id.value = props.update.lotId;
      setProductDetails(props.update.productDetails);
      frmRef.current.batch_id.value = props.update.batchId;
      setRangeDetails(props.update.packedItemIdRange);
      frmRef.current.remark.value = props.update.remark;
    }
  }, [props.update]);

  const submitProduct = (e) => {
    e.preventDefault();
    var itemlist = otherProductData.filter(
      (item) => item.productId == otherProductId
    );
    //console.log("itemlist", otherProductData);

    var selectedItem = itemlist[0];
    var productId1 = otherProductId;
    var itemId = selectedItem.itemId;
    var productName = selectedItem.productName;
    var productSubType = productRef.current.productSubType.value;
    var productType = productRef.current.productType.value;
    var availableQuantity = productRef.current.availableQuantity.value;
    var unit = productRef.current.productUnit.value;
    var unitId1 = unitId;
    var availableAmount1 = availableAmount;
    var itemQuantity = productRef.current.itemQuantity.value;

    setProductDetails((x) => [
      ...x,
      {
        srno:
          productDetails.length > 0
            ? productDetails[productDetails.length - 1].srno + 1
            : 1,
        productId: productId1,
        itemId: itemId,
        productName: productName,
        productSubType: productSubType,
        productType: productType,
        availableQuantity: availableQuantity,
        unit: unit,
        unitId: unitId1,
        availableAmount1: availableAmount1,
        itemQuantity: itemQuantity,
        itemQuantityBal: itemQuantity,
        productCost: 0,
        remark: frmRef.current.remark.value,
        status: 1,
        createdBy: parseInt(localStorage.getItem("id")),
        orgId: localStorage.getItem("orgId"),
        // itemType: productRef.current.itemType.value,
        // itemCategory: productRef.current.itemCategory.value,
        // itemQuantity: productRef.current.itemQuantity.value,
        // unit: productRef.current.unit.value,
        // itemUnitPrice: productRef.current.itemUnitPrice.value,
        // rate: productRef.current.rate.value,
        // currency: productRef.current.currency.value,
        // totalAmount: productRef.current.totalAmount.value,
      },
    ]);

    setotherProductId(0);

    productRef.current.productSubType.value = "";
    productRef.current.productType.value = "";
    productRef.current.availableQuantity.value = "";
    productRef.current.productUnit.value = "";
    setunitId(0);
    setavailableAmount(0);
    productRef.current.itemQuantity.value = "0";
    //console.log(productDetails);
  };

  const handleDelete = (index, e) => {
    setProductDetails(productDetails.filter((v, i) => i !== index));
  };

  const submitRange = (e) => {
    e.preventDefault();
    //console.log("palletId", palletId);
    var palletId1 = palletId;
    var repallter = remainingEmptypalletList.filter(
      (item) => parseInt(item.palletListId) != parseInt(palletId)
    );
    //console.log("repallter", repallter);
    setremainingEmptypalletList(repallter);

    var palletlist = remainingEmptypalletList.filter(
      (item) => parseInt(item.palletListId) == parseInt(palletId)
    );

    var i = 0;
    var newremaingBoxesList = [];
    var newselectedBoxesList = [];

    var selecteditem = 0;
    var boxDetail1 = [];
    var count = remaingBoxesList.length;
    var qty = 0;
    do {
      if (selecteditem == 0) {
        if (remaingBoxesList[i].packedId == fromPackedId) {
          newselectedBoxesList = newselectedBoxesList.concat(
            remaingBoxesList[i]
          );
          boxDetail1 = boxDetail1.concat(remaingBoxesList[i]);
          selecteditem = 1;
          qty++;
        } else {
          newremaingBoxesList = newremaingBoxesList.concat(remaingBoxesList[i]);
        }
      } else {
        newselectedBoxesList = newselectedBoxesList.concat(remaingBoxesList[i]);
        boxDetail1 = boxDetail1.concat(remaingBoxesList[i]);
        qty++;

        if (remaingBoxesList[i].packedId == toPackedId) {
          selecteditem = 0;
        }
      }

      i++;
    } while (count - 1 > i);

    //console.log("lotitem", lotitem);

    var boxDetail = lotitem.boxDetail;
    var palletProductDetail = [
      {
        productId: lotitem.productId,
        productName: lotitem.productName,
        boxQuantity: qty,
        unitId: lotitem.unitId,
        productSubTypeName: lotitem.productSubTypeName,
        productTypeName: lotitem.productTypeName,
        productunitAbbreviation: lotitem.productunitAbbreviation,
        unitAbbreviation: lotitem.unitAbbreviation,
        grossWeightPerCarton: boxDetail && boxDetail.grossWeightPerCarton,
        netWeightPerCarton: boxDetail && boxDetail.netWeightPerCarton,
      },
    ];

    setRangeDetails((x) => [
      ...x,
      {
        palletListId: palletlist[0].palletListId,
        palletNo: palletlist[0].palletNo,
        fromPackedId: fromPackedId,
        toPackedId: toPackedId,
        productDetails: boxDetail1,
        productId: lotitem.productId,
        palletProductDetail: palletProductDetail,
        itemQuantity: qty,
        unitId: lotitem.unitId,
        productCost: 0,
        status: 1,
        createdBy: parseInt(localStorage.getItem("id")),
        createdDate: dateString,
        orgId: localStorage.getItem("orgId"),
      },
    ]);

    setpalletId(0);
    setremaingBoxesList(newremaingBoxesList);
    setselectedBoxesList(newselectedBoxesList);

    setpalletId("--Select Palletization--");
    setfromPackedId("--Select From Packed Id--");
    settoPackedId("--Select To Packed Id--");
  };

  const handleRangeDelete = (index, e) => {
    setRangeDetails(rangeDetails.filter((v, i) => i !== index));
  };

  function getCurrentTime() {
    const now = new Date();
    let hours = now.getHours();
    let minutes = now.getMinutes();

    // Format hours and minutes with leading zeros if necessary
    hours = hours.toString().padStart(2, "0");
    minutes = minutes.toString().padStart(2, "0");

    return `${hours}:${minutes}`;
  }

  const handleValidateQuantityChange = (event) => {
    var validator = new RegExp("^[0-9.]*$");

    var qtyvalid = validator.test(event.target.value);
    //console.log("handleValidateQuantityChange");
    //console.log(qtyvalid);
    if (qtyvalid) {
      var quantity = parseFloat(event.target.value);

      var totalquantity = parseFloat(
        productRef.current.availableQuantity.value
      );

      if (quantity > totalquantity) {
        event.target.value = 0;
        toast.success("Please enter quanitty less than total quantity", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } else {
      event.target.value = 0;
    }
  };

  return (
    <>
      <Modal isOpen={close} style={customModalStyles}>
        <div className="">
          <div>
            <div className="">
              <div className="">
                <h3 className="card-title">Product Details</h3>
                <div className="card-tools text-right">
                  <button
                    type="button"
                    className="btn btn-tool"
                    data-card-widget="remove"
                    onClick={() => setClose(false)}
                  >
                    <i className="fas fa-times" />
                  </button>
                  <hr />
                </div>
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-md-3">
                {" "}
                <label htmlFor={"productId"}> Product Name</label>
                <select
                  id="productId"
                  className="form-control"
                  ref={(el) => (frmRef.current["productId"] = el)}
                  value={otherProductId}
                  onChange={(e) => {
                    setotherProductId(e.target.value);

                    loadStockData(e.target.value);
                  }}
                >
                  <option>--Select Product Name--</option>
                  {otherProductData &&
                    otherProductData.map((x) => (
                      <option
                        key={x.productId}
                        product-id={x.productId}
                        value={x.productId}
                      >
                        {x.productName + "(" + x.itemId + ")"}
                      </option>
                    ))}
                </select>
              </div>
              <div className="col-md-3">
                {" "}
                <label htmlFor={"productId"}> Product SubType </label>{" "}
                <input
                  type={"input"}
                  id={"itemType"}
                  readOnly
                  ref={(el) => (productRef.current["productSubType"] = el)}
                  className="form-control"
                />{" "}
              </div>
              <div className="col-md-3">
                <label htmlFor={"productId"}> Product Type </label>{" "}
                <input
                  type={"input"}
                  id={"productType"}
                  readOnly
                  ref={(el) => (productRef.current["productType"] = el)}
                  className="form-control"
                />{" "}
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-md-3">
                {" "}
                <label htmlFor={"Available"}> Available Quantity</label>
                <input
                  type={"input"}
                  id={"itemType"}
                  readOnly
                  ref={(el) => (productRef.current["availableQuantity"] = el)}
                  className="form-control"
                />
              </div>
              <div className="col-md-3">
                {" "}
                <label htmlFor={"unit"}> Unit</label>
                <input
                  type={"input"}
                  id={"itemType"}
                  readOnly
                  ref={(el) => (productRef.current["productUnit"] = el)}
                  className="form-control"
                />
                <input
                  name="hiddenInput"
                  value=""
                  type="hidden"
                  ref={(el) => (productRef.current["unitId"] = el)}
                />
                <input
                  name="hiddenInput"
                  value=""
                  type="hidden"
                  ref={(el) => (productRef.current["availableAmount"] = el)}
                />
              </div>
              <div className="col-md-3">
                <label htmlFor={"unit"}> Item Quantity</label>
                <input
                  type={"input"}
                  id={"itemType"}
                  ref={(el) => (productRef.current["itemQuantity"] = el)}
                  className="form-control"
                  pattern={decimalPattern}
                  onChange={(e) => {
                    handleValidateQuantityChange(e);
                  }}
                />
              </div>
              <br />
              <div className="col-md-3">
                {" "}
                <button
                  className="btn btn-success mx-2 my-2"
                  onClick={submitProduct}
                >
                  +
                </button>{" "}
              </div>
            </div>

            <hr />

            <div className="">
              <table className="table table-bordered table-responsive">
                <thead>
                  <tr className="tableheaderrow mb-2view">
                    <th>Sr. No</th>
                    <th>Item Id</th>
                    <th>Product Name</th>

                    <th>Item SubType</th>
                    <th>Item Type</th>
                    <th>Available Quantity</th>
                    <th>Unit</th>
                    <th>Item Quantity</th>
                    <th>Unit</th>
                    <th>Delete</th>
                  </tr>
                </thead>
                <tbody>
                  {productDetails &&
                    productDetails.map((itm, i) => {
                      return (
                        <tr key={i.srno}>
                          <td>{itm.srno}</td>
                          <td>{itm.itemId}</td>
                          <td>{itm.productName}</td>
                          <td>{itm.productSubType}</td>
                          <td>{itm.productType}</td>
                          <td>{itm.availableQuantity}</td>
                          <td>{itm.unit}</td>
                          <td>{itm.itemQuantity}</td>
                          <td>{itm.unit}</td>
                          {/* <td>{itm.totalAmount}</td> */}
                          <td>
                            {" "}
                            <button
                              className="btn"
                              onClick={(e) => handleDelete(i, e)}
                            >
                              <i className="fas fa-eye"></i>
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>

            <div className="row mb-2">
              <div className="col-md-3"></div>
              <div className="col-md-2"></div>

              <div className="col-md-2">
                <button
                  className="btn  btn-primary mx-2 my-2"
                  onClick={() => {
                    productDetails.map((x) => (x["isSave"] = true));
                    setClose(false);
                  }}
                >
                  Save
                </button>
              </div>
              <div className="col-md-3"></div>
            </div>
          </div>
        </div>
      </Modal>

      <Modal isOpen={rangeClose} style={customModalStyles}>
        <div className="">
          <div>
            <div className="">
              <div className="">
                <h3 className="card-title">Pallet Details</h3>
                <div className="card-tools text-right">
                  <button
                    type="button"
                    className="btn btn-tool"
                    data-card-widget="remove"
                    onClick={() => setRangeClose(false)}
                  >
                    <i className="fas fa-times" />
                  </button>
                  <hr />
                </div>
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-md-3">
                {" "}
                <label htmlFor={"palletizationId"}> Palletization id</label>
                <select
                  id="PalletizationId"
                  className="form-control"
                  ref={(el) => (frmRef.current["PalletizationId"] = el)}
                  value={palletId}
                  onChange={(e) => {
                    setpalletId(e.target.value);
                  }}
                >
                  <option>--Select Palletization--</option>
                  {remainingEmptypalletList &&
                    remainingEmptypalletList.map((x) => (
                      <option value={x.palletListId} key={x.palletListId}>
                        {x.palletNo}
                      </option>
                    ))}
                </select>
              </div>
              <div className="col-md-3">
                {" "}
                <label htmlFor={"PackedId"}> Packed Id(From) </label>{" "}
                <select
                  id="fromPackedId"
                  className="form-control"
                  ref={(el) => (frmRef.current["fromPackedId"] = el)}
                  value={fromPackedId}
                  onChange={(e) => {
                    setfromPackedId(e.target.value);
                  }}
                >
                  <option>--Select From Packed Id--</option>
                  {remaingBoxesList &&
                    remaingBoxesList.map((x, i) => (
                      <option value={x.packedId} key={i}>
                        {x.packedId}
                      </option>
                    ))}
                </select>
              </div>
              <div className="col-md-3">
                <label htmlFor={"PackedId"}> Packed Id(To) </label>{" "}
                <select
                  id="toPackedId"
                  className="form-control"
                  ref={(el) => (frmRef.current["toPackedId"] = el)}
                  value={toPackedId}
                  onChange={(e) => {
                    settoPackedId(e.target.value);
                  }}
                >
                  <option>--Select To Packed Id--</option>
                  {remaingBoxesList &&
                    remaingBoxesList.map((x, i) => (
                      <option value={x.packedId} key={i}>
                        {x.packedId}
                      </option>
                    ))}
                </select>
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-md-3">
                {" "}
                <button
                  className="btn btn-success mx-2 my-2"
                  onClick={submitRange}
                >
                  +
                </button>{" "}
              </div>
            </div>

            <hr />

            <div className="">
              <table className="table table-bordered table-responsive">
                {" "}
                <thead>
                  <tr className="tableheaderrow mb-2view">
                    <th>pallet No</th>
                    <th>Item id (From)</th>
                    <th>Item id(to)</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {rangeDetails &&
                    rangeDetails.map((itm, i) => {
                      return (
                        <tr key={i}>
                          <td>{itm.palletNo}</td>
                          <td>{itm.fromPackedId}</td>
                          <td>{itm.toPackedId}</td>

                          <td className="text-center">
                            <button
                              className="list-edit"
                              onClick={(e) => handleRangeDelete(i, e)}
                            >
                              delete
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>

            <div className="row mb-2">
              <div className="col-md-3"></div>
              <div className="col-md-2"></div>

              <div className="col-md-2">
                <button
                  className="btn  btn-primary mx-2 my-2"
                  onClick={() => {
                    rangeDetails.map((x) => (x["isSave"] = true));
                    setRangeClose(false);
                  }}
                >
                  Save
                </button>
              </div>
              <div className="col-md-3"></div>
            </div>
          </div>
        </div>
      </Modal>

      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <form style={{ margin: "10px" }} onSubmit={submitHandler}>
            <div className="container-fluid">
              {/* SELECT2 EXAMPLE */}
              <div className="card card-default">
                <div className="card-header">
                  <h3 className="card-title">Palletization Detail</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4">
                      <label htmlFor={"date"}>{"Date "}</label>
                      <input
                        type={"date"}
                        id={"date"}
                        required
                        ref={(el) => (frmRef.current["date"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedDate}
                        onChange={handleDateChange}
                      />
                    </div>

                    <div className="col-md-4">
                      <label htmlFor={"emp_id"}>{"Packhouse Employee"}</label>
                      <select
                        id="emp_id"
                        className="form-control"
                        ref={(el) => (frmRef.current["assignEmployeeId"] = el)}
                        value={assignEmployeeId}
                        onChange={(e) => {
                          setAssignEmployeeId(e.target.value);
                        }}
                      >
                        <option>--Select Employee--</option>
                        {employeelist &&
                          employeelist.map((x) => (
                            <option
                              key={x.empId}
                              employee-id={x.empId}
                              value={x.empId}
                            >
                              {x.employeeName}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-4">
                      <label htmlFor={"packing_time"}>Packing Time</label>

                      <input
                        type={"time"}
                        id={"packingTime"}
                        required
                        ref={(el) => (frmRef.current["packingTime"] = el)}
                        className="form-control"
                        defaultValue={getCurrentTime()}
                        onChange={(e) => {
                          //console.log(e.target.value);
                          // setpackingTime(e.target.value);
                          // labelingRef.current.timeStamp.value=e.target.value;
                        }}
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      {" "}
                      <label htmlFor={"lot_id"}>{"Lot id "}</label>
                      <select
                        id="lot_id"
                        className="form-control"
                        ref={(el) => (frmRef.current["lot_id"] = el)}
                        onChange={handleLotIdChange}
                      >
                        <option>--Select Lot No--</option>
                        {lotData &&
                          lotData.map((x, i) => (
                            <option value={x.stockId} key={i}>
                              {x.lotNo + "(" + x.productName + ")"}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-4">
                      <label htmlFor={"batch_id"}> {"Batch No"}</label>
                      <input
                        type={"input"}
                        id={"batchNo"}
                        readOnly
                        defaultValue={batchNo}
                        ref={(el) => (frmRef.current["batchNo"] = el)}
                        className="form-control"
                        onChange={(e) => {
                          //console.log(e.target.value);
                          // setpackingTime(e.target.value);
                          // labelingRef.current.timeStamp.value=e.target.value;
                        }}
                      />
                    </div>

                    <div className="col-md-4">
                      <label htmlFor={"batch_id"}>
                        {" "}
                        {"Available Box Count"}
                      </label>
                      <input
                        type={"input"}
                        id={"availableBoxCount"}
                        readOnly
                        defaultValue={availableBoxCount}
                        ref={(el) => (frmRef.current["availableBoxCount"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <label htmlFor={"packed_item_id_range"}>
                        {"Packed Item id Range"}
                      </label>
                      <br />
                      &nbsp;&nbsp;
                      <button
                        className="btn btn-sm btn-warning"
                        onClick={(e) => {
                          e.preventDefault(false);
                          rangeDetails &&
                            setRangeDetails((items) =>
                              items.filter((x) => x.isSave)
                            );
                          setRangeClose(true);
                        }}
                      >
                        Add
                      </button>
                    </div>
                    <div className="col-md-4">
                      {" "}
                      <label htmlFor={"product_details"}>
                        {" "}
                        {"Product Details"}
                      </label>
                      <br />
                      &nbsp;&nbsp;
                      <button
                        className="btn btn-sm btn-success"
                        onClick={(e) => {
                          e.preventDefault(false);
                          productDetails &&
                            setProductDetails((items) =>
                              items.filter((x) => x.isSave)
                            );
                          setClose(true);
                        }}
                      >
                        Add
                      </button>
                    </div>

                    <div className="col-md-4">
                      <label htmlFor={"remark"}>{"Remark/Note"}</label>
                      <input
                        type={"text"}
                        id={"remark"}
                        required
                        ref={(el) => (frmRef.current["remark"] = el)}
                        className="form-control"
                      />{" "}
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4"></div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-1">
                      {" "}
                      <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={loading}
                      >
                        {loading ? "Submitting..." : "Submit"}
                      </button>
                    </div>
                    <div className="col-md-1">
                      {/* <button className="btn  btn-primary mx-2 my-2" type="submit">
                Cancel
              </button> */}
                    </div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-4"></div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
    </>
  );
};

export default PalletizationForm;
